import {createAsyncThunk} from '@reduxjs/toolkit';

import {
  getMosaicById,
  getMosaicByName,
  getMosaicsForSeries,
} from '@explorer/api/mosaics';

export const selectMosaic = createAsyncThunk(
  'mosaics/select',
  async (mosaicId, {getState}) => {
    let mosaicInfo = null;
    if (mosaicId) {
      const state = getState();

      if (state.mosaics.list) {
        mosaicInfo = state.mosaics.list.filter(
          mosaic => mosaic.id === mosaicId
        )[0];
      }

      if (!mosaicInfo) {
        const seriesInfo = state.series.byId[state.series.selectedId];
        mosaicInfo = await getMosaicById(mosaicId);
        mosaicInfo = {
          ...mosaicInfo,
          seriesId: seriesInfo.id,
          seriesName: seriesInfo.name,
        };
      }
    }
    return mosaicInfo;
  }
);

export const selectMosaicByName = createAsyncThunk(
  'mosaics/selectByName',
  async (mosaicName, {getState}) => {
    let mosaicInfo = null;
    if (mosaicName) {
      const state = getState();

      if (state.mosaics.list) {
        mosaicInfo = state.mosaics.list.filter(
          mosaic => mosaic.name === mosaicName
        )[0];
      }

      if (!mosaicInfo) {
        const seriesInfo = state.series.byId[state.series.selectedId];
        mosaicInfo = await getMosaicByName(mosaicName);
        if (mosaicInfo) {
          mosaicInfo = {
            ...mosaicInfo,
            seriesId: seriesInfo.id,
            seriesName: seriesInfo.name,
          };
        }
      }
    }
    return mosaicInfo;
  }
);

export const fetchSeriesMosaicsRequest = createAsyncThunk(
  'mosaics/fetchForSeries',
  async (seriesId, {dispatch, getState}) => {
    const state = getState();
    const series = state.series.byId[seriesId];
    const mosaics = await getMosaicsForSeries(seriesId);
    const mosaicId = state.series.lastSelectedMosaics[seriesId];

    if (mosaicId) {
      dispatch(selectMosaic(mosaicId));
    }

    return {
      seriesId: series.id,
      seriesName: series.name,
      mosaics,
    };
  }
);
